export default function (contentHtml) {
  const mainSection = document.getElementById('main-section');
  mainSection.innerHTML = mainSection.innerHTML + contentHtml;

  document.documentElement.classList.add('is-clipped');
}
